import { DropdownOption } from '../dropdown/Dropdown';
import { Action } from '../modal/ActionModal';

/* eslint-disable @typescript-eslint/no-explicit-any */

export interface ArkTableComponents {
    tooltip: React.FC;
    iconTooltip: React.FC;
    tooltipList: React.FC;
    tooltipListLabel: React.FC;
    deadline: React.FC;
    action: React.FC;
    analysis: React.FC;
    select: React.FC;
    checkbox: React.FC;
    icon: React.FC;
    tick: React.FC;
    address: React.FC;
    flag: React.FC;
    colour: React.FC;
    table: React.FC;
    redirect: React.FC;
    entity: React.FC;
    disabled: React.FC;
    colorDate: React.FC;
    otherNames: React.FC;
    nettingAnalysis: React.FC;
    riskFieldValue: React.FC;
}

export interface DateCellColourBoundaries {
    red: number;
    amber: number;
}

export interface ArkTableColumn {
    id: string;
    field: string;
    description?: string;
    header: string;
    component?: keyof ArkTableComponents;
    secondaryComponent?: keyof ArkTableComponents;
    actions?: (data: any) => Action[];
    icon?: React.FC;
    valueFormatter?: (value: any, row: any, index?: number) => string | string[] | boolean | null;
    selectedIds?: number[] | string[] | null;
    selected?: number[];
    select?: (selectedId: number | string) => void;
    deselect?: (selectedId: number | string) => void;
    selectDisabled?: (selectedId: number) => boolean;
    canFilter?: boolean;
    canSort?: boolean;
    width: number | string;
    parentField?: string;
    redirect?: (row: any) => void;
    disabled?: (row: any) => boolean;
    isLoading?: (row: any) => boolean;
    colours?: DateCellColourBoundaries;
}

export interface ArkRow {
    [property: string]: any;
}

export enum SortOrder {
    ASCENDING = 'ASC',
    DESCENDING = 'DESC'
}

export interface ColumnSort {
    field: string;
    order: SortOrder;
}

export interface SelectedArkRow {
    field: string;
    fieldValue: any;
}

export interface TableFilterType {
    text: string;
    dropdown: string[] | null;
}

export interface TableFilters {
    [field: string]: TableFilterType;
}

export interface FilterDropdownOptions {
    [field: string]: DropdownOption[];
}
